module.exports = __webpack_public_path__ + "static/img/图层 568.ec5107b1.png";